import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { AdjustmentReasonRepositoryBase } from '@skylab-shared/business';
export { AdjustmentReasonRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(AdjustmentReasonRepositoryBase)
export class AdjustmentReasonRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
    ) { }
}
